export const URLS = {
  HOME: "/home",
  ADMIN: "/admin",
  MEMBERS: "/members",
  TRAINERS: "/trainers",
  USERS: "/dashboard",
  TRAINERS_DASHBOARD: "/trainer-dashboard",
  PRICE_PACKAGE: "/price-package",
  PREMIUM_MEMBERS: "/premium-members",
  SHARE: "/share/:token",
  MUSIC: "/admin/music",
};
